import axios from "axios";

export const getStatuses = async () => {
    const response = await axios.get("api/taskstatuses");
    const result = response.data;
    return result;
}

